import { useState, useEffect } from "react";
import { openLink } from "../../../../functions/functions";
import PlayerGeneralComponent from "./playerGeneral";
import ScoreGeneralComponent from "./scoreGeneral";

/**
 * Componente que muestra los equipos de un evento deportivo general
 * Renderiza ambos equipos (local y visitante) con sus imágenes y nombres
 * Incluye funcionalidad de click para navegar a estadísticas del evento
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.item - Datos del evento deportivo
 * @param {string} props.item.left_image - URL de la imagen del equipo local
 * @param {string} props.item.left_name - Nombre del equipo local
 * @param {string} props.item.right_image - URL de la imagen del equipo visitante
 * @param {string} props.item.right_name - Nombre del equipo visitante
 * @param {string} props.item.opta_event_url - URL para estadísticas del evento
 * @param {string} props.url - URL base para imágenes por defecto
 * @param {Array} props.leftBlockClasses - Clases CSS para el contenedor de equipos
 * 
 * @returns {JSX.Element} Contenedor con ambos equipos y separador visual
 */
export default function EquiposGeneralComponent({ item, url, leftBlockClasses, rightBlockClasses, norm, gameClass, isErrorGame, time_format, isTenis, tenis_fase }) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 480);

  // detecta el tamaño de la pantalla para establecer el mobile
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Destructuring para mejor legibilidad
  const { right_image, right_name, left_image, left_name, opta_event_url, left_short_name, right_short_name, period_title, utc_date } = item;

  // Usar nombres cortos en pantallas pequeñas
  const leftDisplayName = left_name; //isSmallScreen ? (left_short_name || left_name) : left_name;
  const rightDisplayName = right_name; //isSmallScreen ? (right_short_name || right_name) : right_name;

  /**
   * Maneja el click en el contenedor de equipos
   * Navega a las estadísticas del evento si hay URL disponible
   */
  const handleClick = () => {
    if (opta_event_url) {
      openLink(opta_event_url, true);
    }
  };

  return (
    <div
      className={leftBlockClasses.join(" ")}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label={`Ver estadísticas del partido: ${left_name} vs ${right_name}`}
      title="Click para ver estadísticas del evento"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {/* Equipo local */}
      <PlayerGeneralComponent
        image={left_image}
        name={leftDisplayName}
        position={"left"}
        url={url}
      />

      {/* SECCIÓN DERECHA - Puntajes (para envivo o finalizados) */}
      <ScoreGeneralComponent
        item={item}
        rightBlockClasses={rightBlockClasses}
        norm={norm}
        clickScore={() => openLink(opta_event_url, true)}
        gameClass={gameClass} isErrorGame={isErrorGame}

        clase={item.class}
        opta_event_url={opta_event_url}
        period_title={period_title}
        utc_date={utc_date}
        time_format={time_format}
        isTenis={isTenis}
        tenis_fase={tenis_fase}
      />

      {/* Equipo visitante */}
      <PlayerGeneralComponent
        image={right_image}
        name={rightDisplayName}
        position={"right"}
        url={url}
      />
    </div>
  );
}